import { useCallback, useMemo } from 'react';

import type {
  SidebarCardId,
  SidebarSectionId,
} from 'components/conversation/components/sidebar/conversationSidebar.types';
import { useServerStorage } from 'utils/useServerStorage';

export function useCardSectionVisibility(): {
  readonly hiddenItems: Set<SidebarCardId | SidebarSectionId>;
  readonly toggleItemVisibility: (
    cardId: SidebarCardId | SidebarSectionId,
  ) => void;
} {
  const storage = useServerStorage('user');

  const toggleItemVisibility = useCallback(
    (cardId: SidebarCardId | SidebarSectionId) => {
      storage.set({
        conversation: (draft) => {
          const hidden = new Set(draft.sidebarHiddenItems ?? []);
          hidden.has(cardId) ? hidden.delete(cardId) : hidden.add(cardId);
          draft.sidebarHiddenItems = [...hidden];
        },
      });
    },
    [storage],
  );

  return useMemo(
    () => ({
      hiddenItems: new Set(storage.data.conversation?.sidebarHiddenItems ?? []),
      toggleItemVisibility,
    }),
    [storage.data.conversation?.sidebarHiddenItems, toggleItemVisibility],
  );
}
